// PLACA 5 — mejoras de carga percibida. Sin dependencias.
// Borra este archivo y su <script> en layout/theme.liquid para revertir.

(() => {
  const conexion = navigator.connection;
  const ahorroDatos = conexion && (conexion.saveData || /2g/.test(conexion.effectiveType || ''));

  /* 1. Prefetch al pasar el ratón o al tocar.
        Cuando el visitante suelta el clic, el HTML ya está en caché. */
  if (!ahorroDatos) {
    const pedidos = new Set();

    const prefetch = (url) => {
      if (pedidos.has(url) || pedidos.size > 12) return;
      pedidos.add(url);
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    };

    const candidata = (a) => {
      if (!a || !a.href || a.target === '_blank') return null;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return null;
      if (url.pathname === location.pathname) return null;
      if (/\/(cart|checkout|account)/.test(url.pathname)) return null;
      return url.href;
    };

    let temporizador;
    document.addEventListener('pointerover', (e) => {
      const a = e.target.closest('a');
      const url = candidata(a);
      if (!url) return;
      clearTimeout(temporizador);
      temporizador = setTimeout(() => prefetch(url), 90);
    }, { passive: true });

    document.addEventListener('pointerout', () => clearTimeout(temporizador), { passive: true });
    document.addEventListener('touchstart', (e) => {
      const url = candidata(e.target.closest('a'));
      if (url) prefetch(url);
    }, { passive: true });
  }

  /* 2. Esqueleto en las imágenes hasta que terminan de decodificar. */
  const marcar = (img) => {
    if (img.dataset.p5 === 'ok') return;
    if (img.complete && img.naturalWidth > 0) {
      img.dataset.p5 = 'ok';
      return;
    }
    img.dataset.p5 = 'cargando';
    const listo = () => { img.dataset.p5 = 'ok'; };
    img.addEventListener('load', listo, { once: true });
    img.addEventListener('error', listo, { once: true });
  };

  const revisar = (raiz) => raiz.querySelectorAll?.('img').forEach(marcar);

  revisar(document);
  new MutationObserver((muts) => {
    for (const m of muts) m.addedNodes.forEach((n) => n.nodeType === 1 && revisar(n));
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* 3. Vídeos en bucle (bloque de confianza): solo se reproducen
        mientras están a la vista, y nunca con «reducir movimiento». */
  const bucles = document.querySelectorAll('[data-placa5-loop]');
  if (bucles.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const vista = new IntersectionObserver((entradas) => {
      for (const e of entradas) e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause();
    }, { threshold: 0.25 });
    bucles.forEach((v) => vista.observe(v));
  }

  /* 4. Barra de progreso mientras navega. */
  const barra = document.createElement('div');
  barra.className = 'p5-progreso';
  let activa;

  addEventListener('pagehide', () => clearTimeout(activa));
  document.addEventListener('click', (e) => {
    const url = e.target.closest('a');
    if (!url || !url.href || e.metaKey || e.ctrlKey || e.shiftKey || url.target === '_blank') return;
    const destino = new URL(url.href, location.href);
    if (destino.origin !== location.origin || destino.pathname === location.pathname) return;
    activa = setTimeout(() => {
      if (!barra.isConnected) document.body.appendChild(barra);
      barra.dataset.estado = 'activa';
    }, 150);
  });

  const reducido = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Check con estallido del botón de la cesta (assets/icon-checkmark-burst.svg),
     reservado para «mensaje enviado». marcarCheck() lo dispara: data-p5-check
     pasa de «listo» a «hecho» y el CSS reproduce la secuencia del botón. */
  const rayos = Array.from(
    { length: 8 },
    (_, i) =>
      `<g style="--i:${i}"><line class="p5-line" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor" stroke-linecap="round"/></g>`
  ).join('');
  const crearCheck = () =>
    `<svg class="p5-checkburst" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><g class="p5-check"><circle class="p5-ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path class="p5-tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><g class="p5-burst">${rayos}</g></svg>`;

  const marcarCheck = (el) => {
    el.dataset.p5Check = 'listo';
    void el.offsetWidth;
    el.dataset.p5Check = 'hecho';
  };

  /* La pastilla negra (filtros, índice, motivos) se coloca sobre el elemento elegido. */
  const colocarPastilla = (pastilla, el) => {
    pastilla.style.setProperty('--x', `${el.offsetLeft}px`);
    pastilla.style.setProperty('--y', `${el.offsetTop}px`);
    pastilla.style.setProperty('--w', `${el.offsetWidth}px`);
    pastilla.style.setProperty('--h', `${el.offsetHeight}px`);
  };

  /* 5. Filtros de la tienda. La pastilla se desliza al chip elegido y
        las tarjetas se recolocan dentro de una transición de vista;
        el hash (#resenas, #carta…) permite enlazar un filtro. */
  const tienda = document.querySelector('[data-p5-tienda]');
  const filtros = tienda?.querySelector('.p5-filtros');
  if (filtros) {
    const mapa = JSON.parse(tienda.querySelector('[data-p5-mapa]').textContent);
    const chips = [...filtros.querySelectorAll('[data-p5-filtro]')];
    const pastilla = filtros.querySelector('.p5-filtros__pastilla');
    const aviso = tienda.querySelector('[data-p5-aviso]');
    const tarjetas = [...document.querySelectorAll('.product-grid__item')].map((li) => {
      const enlace = li.querySelector('a[href*="/products/"]');
      const handle = enlace ? new URL(enlace.href).pathname.split('/products/')[1] : '';
      return { li, etiquetas: mapa[handle] || [] };
    });
    const conTransicion = 'startViewTransition' in document && !reducido;
    const activo = () => chips.find((c) => c.getAttribute('aria-pressed') === 'true');

    const filtrar = (etiqueta) => {
      let visibles = 0;
      for (const t of tarjetas) {
        const entra = !etiqueta || t.etiquetas.includes(etiqueta);
        t.li.classList.toggle('p5-fuera', !entra);
        if (entra) visibles++;
      }
      aviso.textContent = `${visibles} ${visibles === 1 ? 'producto' : 'productos'}`;
    };

    const elegir = (chip, animar) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      colocarPastilla(pastilla, chip);
      filtros.scrollTo({
        left: chip.offsetLeft - (filtros.clientWidth - chip.offsetWidth) / 2,
        behavior: animar && !reducido ? 'smooth' : 'auto',
      });
      const destino = chip.dataset.p5Slug ? `#${chip.dataset.p5Slug}` : location.pathname + location.search;
      if (animar || chip.dataset.p5Slug) history.replaceState(history.state, '', destino);

      if (!animar || !conTransicion) return filtrar(chip.dataset.p5Filtro);

      tarjetas.forEach((t, i) => {
        t.li.style.viewTransitionName = `p5-tarjeta-${i}`;
        t.li.style.viewTransitionClass = 'p5-tarjeta';
      });
      document.documentElement.classList.add('p5-filtrando');
      document.startViewTransition(() => filtrar(chip.dataset.p5Filtro)).finished.finally(() => {
        document.documentElement.classList.remove('p5-filtrando');
        tarjetas.forEach((t) => {
          t.li.style.viewTransitionName = '';
          t.li.style.viewTransitionClass = '';
        });
      });
    };

    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        if (chip !== activo()) elegir(chip, true);
      })
    );

    const desdeHash = () => chips.find((c) => c.dataset.p5Slug && `#${c.dataset.p5Slug}` === location.hash) || chips[0];
    elegir(desdeHash(), false);
    addEventListener('hashchange', () => {
      if (desdeHash() !== activo()) elegir(desdeHash(), true);
    });
    new ResizeObserver(() => colocarPastilla(pastilla, activo())).observe(filtros);
    requestAnimationFrame(() => (filtros.dataset.listo = ''));
  }

  /* 6. Bloque de confianza: las piezas entran por turnos y, con ratón,
        se inclinan hacia el cursor con un brillo que lo sigue. */
  const bento = document.querySelector('[id$="__confianza_home"] .section-content-wrapper');
  if (bento && 'IntersectionObserver' in window && !reducido) {
    const piezas = [...bento.children].filter((n) => n.classList.contains('group-block'));
    bento.classList.add('p5-bento-preparado');

    const vista = new IntersectionObserver(
      (entradas) => {
        entradas
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left)
          .forEach((e, i) => {
            e.target.style.setProperty('--p5-retardo', `${i * 90}ms`);
            e.target.classList.add('p5-visto');
            vista.unobserve(e.target);
          });
      },
      { threshold: 0.3 }
    );

    piezas.forEach((pieza) => {
      vista.observe(pieza);
      pieza.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const caja = pieza.getBoundingClientRect();
        const x = (e.clientX - caja.left) / caja.width;
        const y = (e.clientY - caja.top) / caja.height;
        pieza.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
        pieza.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
        pieza.style.setProperty('--rx', `${((0.5 - y) * 5).toFixed(2)}deg`);
        pieza.style.setProperty('--ry', `${((x - 0.5) * 5).toFixed(2)}deg`);
      });
      pieza.addEventListener('pointerleave', () => {
        pieza.style.setProperty('--rx', '0deg');
        pieza.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* 7. Páginas tipo documento (templates/page.documento.json). La
        pastilla marca el apartado en curso y el aro de cada número se
        llena con lo leído de su apartado; en móvil, un anillo enseña
        el progreso total. */
  const doc = document.querySelector('[data-p5-doc]');
  if (doc) {
    const cuerpo = doc.querySelector('.p5-doc__cuerpo');
    const apartados = [...doc.querySelectorAll('[data-p5-apartado]')];
    const indice = doc.querySelector('[data-p5-indice]');
    const enlaces = indice ? [...indice.querySelectorAll('[data-p5-ir]')] : [];
    const pasos = doc.classList.contains('p5-doc--como-funciona') ? [...cuerpo.querySelectorAll('h3')] : [];
    pasos.forEach((h3) => h3.insertAdjacentHTML('afterbegin', '<span class="p5-paso" aria-hidden="true"></span>'));

    let enCurso = -1;
    const actualizar = () => {
      const linea = innerHeight * 0.3;
      const buscando = doc.hasAttribute('data-p5-buscando');
      const caja = cuerpo.getBoundingClientRect();
      const recorrido = caja.height - innerHeight + linea;
      const progreso = buscando ? 0 : recorrido > 0 ? Math.min(1, Math.max(0, (linea - caja.top) / recorrido)) : 1;

      let actual = Math.max(0, apartados.findIndex((s) => !s.hidden));
      apartados.forEach((s, i) => {
        const r = s.getBoundingClientRect();
        if (!s.hidden && r.top <= linea) actual = i;
        const li = enlaces[i]?.parentElement;
        if (!li) return;
        const leido = buscando || s.hidden ? 0 : progreso > 0.995 ? 1 : Math.min(1, Math.max(0, (linea - r.top) / r.height));
        li.style.setProperty('--p', leido.toFixed(3));
        li.toggleAttribute('data-leido', leido >= 1);
      });
      pasos.forEach((h3) => h3.toggleAttribute('data-alcanzado', h3.getBoundingClientRect().top <= innerHeight * 0.55));

      if (indice) {
        indice.style.setProperty('--p', progreso.toFixed(3));
        if (actual !== enCurso && enlaces[actual]) {
          enCurso = actual;
          enlaces.forEach((a, i) => (i === actual ? a.setAttribute('aria-current', 'location') : a.removeAttribute('aria-current')));
          colocarPastilla(indice.querySelector('.p5-doc__pastilla'), enlaces[actual]);
          const dos = (n) => String(n).padStart(2, '0');
          indice.querySelector('[data-p5-actual-num]').textContent = `${dos(actual + 1)} / ${dos(apartados.length)}`;
          indice.querySelector('[data-p5-actual-titulo]').textContent = enlaces[actual].querySelector('.p5-doc__nombre').textContent;
        }
      }
    };

    let pendiente = false;
    const programar = () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => {
        pendiente = false;
        actualizar();
      });
    };
    /* Savor hace el scroll dentro de .page-wrapper, no en la ventana:
       en captura se oye el de cualquier contenedor. */
    document.addEventListener('scroll', programar, { capture: true, passive: true });
    addEventListener('resize', () => {
      enCurso = -1;
      programar();
    });
    actualizar();

    if (indice) {
      requestAnimationFrame(() => (indice.dataset.listo = ''));
      const boton = indice.querySelector('[data-p5-actual]');
      const abrir = (si) => {
        indice.toggleAttribute('data-abierto', si);
        boton.setAttribute('aria-expanded', String(si));
      };
      boton.addEventListener('click', () => abrir(!indice.hasAttribute('data-abierto')));
      document.addEventListener('click', (e) => {
        if (!indice.contains(e.target)) abrir(false);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') abrir(false);
      });
      enlaces.forEach((a) =>
        a.addEventListener('click', (e) => {
          const destino = document.getElementById(decodeURIComponent(a.hash.slice(1)));
          if (!destino) return;
          e.preventDefault();
          abrir(false);
          destino.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(history.state, '', a.hash);
        })
      );
    }

    /* Al imprimir se abren todas las respuestas de la FAQ */
    const cerradas = [];
    addEventListener('beforeprint', () =>
      doc.querySelectorAll('details:not([open])').forEach((d) => {
        cerradas.push(d);
        d.open = true;
      })
    );
    addEventListener('afterprint', () => cerradas.splice(0).forEach((d) => (d.open = false)));

    /* Buscador de la FAQ: filtra sin acentos y abre lo que encuentra */
    const buscador = doc.querySelector('[data-p5-buscar]');
    if (buscador) {
      const preguntas = [...doc.querySelectorAll('[data-p5-pregunta]')];
      const normalizar = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      const textos = preguntas.map((p) => normalizar(p.textContent));
      const resultados = doc.querySelector('[data-p5-resultados]');
      const vacio = doc.querySelector('[data-p5-vacio]');
      const abiertasPorBusqueda = new Set();

      buscador.addEventListener('input', () => {
        const palabras = normalizar(buscador.value).split(/\s+/).filter(Boolean);
        let encontradas = 0;
        preguntas.forEach((p, i) => {
          const entra = palabras.every((w) => textos[i].includes(w));
          p.hidden = !entra;
          if (entra) encontradas++;
          const abrir = entra && palabras.join('').length >= 3;
          if (abrir && !p.open) {
            p.open = true;
            abiertasPorBusqueda.add(p);
          } else if (!abrir && abiertasPorBusqueda.has(p)) {
            p.open = false;
            abiertasPorBusqueda.delete(p);
          }
        });
        apartados.forEach((s, i) => {
          s.hidden = !s.querySelector('[data-p5-pregunta]:not([hidden])');
          if (enlaces[i]) enlaces[i].parentElement.hidden = s.hidden;
        });
        doc.toggleAttribute('data-p5-buscando', palabras.length > 0);
        vacio.hidden = encontradas > 0;
        indice?.toggleAttribute('data-vacio', encontradas === 0);
        resultados.textContent = palabras.length && encontradas
          ? `${encontradas} ${encontradas === 1 ? 'pregunta' : 'preguntas'}`
          : '';
        enCurso = -1;
        programar();
      });
    }
  }

  /* 8. Contacto: etiquetas flotantes (el placeholder sube al escribir),
        motivo del mensaje (cambia la etiqueta del comentario y viaja
        como campo «Motivo» en el correo que recibís) y el check de la
        cesta solo al enviar. */
  const formulario = document.querySelector('.contact-form__form');
  if (formulario) {
    const etiquetas = new Map();
    formulario.querySelectorAll('.contact-form__input').forEach((campo) => {
      const envoltorio = document.createElement('span');
      envoltorio.className = 'p5-campo';
      campo.before(envoltorio);
      envoltorio.append(campo);
      const etiqueta = document.createElement('span');
      etiqueta.className = 'p5-campo__etiqueta';
      etiqueta.setAttribute('aria-hidden', 'true');
      etiqueta.textContent = campo.placeholder;
      envoltorio.append(etiqueta);
      etiquetas.set(campo, etiqueta);
      campo.placeholder = ' ';
    });

    const comentario = formulario.querySelector('textarea');
    const motivos = document.querySelector('[data-p5-motivos]');
    if (motivos && comentario) {
      const grupo = motivos.querySelector('.p5-filtros');
      const chips = [...motivos.querySelectorAll('[data-p5-motivo]')];
      const pastilla = motivos.querySelector('.p5-filtros__pastilla');
      const campo = Object.assign(document.createElement('input'), { type: 'hidden', name: 'contact[Motivo]' });
      formulario.append(campo);
      const etiqueta = etiquetas.get(comentario);
      const elegido = () => chips.find((c) => c.getAttribute('aria-pressed') === 'true');

      chips.forEach((chip) =>
        chip.addEventListener('click', () => {
          chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          colocarPastilla(pastilla, chip);
          requestAnimationFrame(() => (grupo.dataset.listo = ''));
          campo.value = chip.dataset.p5Motivo;
          if (etiqueta && etiqueta.textContent !== chip.dataset.p5Pista) {
            etiqueta.classList.remove('p5-cambia');
            void etiqueta.offsetWidth;
            etiqueta.textContent = chip.dataset.p5Pista;
            etiqueta.classList.add('p5-cambia');
          }
        })
      );
      new ResizeObserver(() => elegido() && colocarPastilla(pastilla, elegido())).observe(grupo);
    }

    if (comentario) {
      const crecer = () => {
        comentario.style.height = 'auto';
        comentario.style.height = `${Math.max(comentario.scrollHeight + 2, 128)}px`;
      };
      comentario.addEventListener('input', crecer);
    }

    const enviar = formulario.querySelector('[type="submit"]');
    const textoEnviar = enviar?.textContent;
    formulario.addEventListener('submit', () => {
      if (!enviar) return;
      enviar.setAttribute('aria-busy', 'true');
      enviar.textContent = 'Enviando…';
    });
    /* Si vuelve con el botón «atrás», el botón no se queda bloqueado */
    addEventListener('pageshow', (e) => {
      if (!e.persisted || !enviar) return;
      enviar.removeAttribute('aria-busy');
      enviar.textContent = textoEnviar;
    });

    const exito = formulario.querySelector('.contact-form__success');
    if (exito) {
      exito.insertAdjacentHTML('afterbegin', `<span class="p5-exito" aria-hidden="true">${crearCheck()}</span>`);
      const sello = exito.firstElementChild;
      sello.dataset.p5Check = 'listo';
      setTimeout(() => marcarCheck(sello), 250);
    }
  }

  /* 9. Guía de configuración (templates/page.configurar.json). Eliges
        tu tarjeta en el abanico y la página baja a su guía, que cambia
        textos, fotos y pantallas. El hash (#wifi…) llega desde las
        fichas y salta el abanico. Al bajar, el paso que se lee
        enciende su pantalla en el móvil. */
  const guia = document.querySelector('[data-p5-cfg]');
  if (guia) {
    const botones = [...guia.querySelectorAll('[data-p5-tipo]')];
    const variantes = [...guia.querySelectorAll('[data-para]')];
    const pasos = [...guia.querySelectorAll('.p5-cfg__paso')];
    const escena = guia.querySelector('[data-p5-escena]');
    const pantallas = [...escena.querySelectorAll('.p5-ui')];
    const destino = guia.querySelector('[data-p5-guia]');
    const rotulo = guia.querySelector('[data-p5-rotulo]');
    let tipoActual = 'google';

    const aplicar = (tipo) => {
      tipoActual = tipo;
      botones.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.p5Tipo === tipo)));
      variantes.forEach((v) => (v.hidden = !v.dataset.para.split(' ').includes(tipo)));
      /* La pantalla en curso vuelve a empezar su bucle con el contenido nuevo */
      const encendida = pantallas.find((p) => p.classList.contains('p5-activa'));
      if (encendida) {
        encendida.classList.remove('p5-activa');
        void encendida.offsetWidth;
        encendida.classList.add('p5-activa');
      }
    };

    const elegir = (boton) => {
      guia.dataset.elegida = '';
      history.replaceState(history.state, '', `#${boton.dataset.p5Tipo}`);
      aplicar(boton.dataset.p5Tipo);
      destino.scrollIntoView({ block: 'start', behavior: reducido ? 'auto' : 'smooth' });
    };

    botones.forEach((b) => b.addEventListener('click', () => elegir(b)));

    /* Escritorio: el nombre de la carta aparece bajo el abanico */
    botones.forEach((carta) => {
      const nombre = carta.querySelector('.p5-mazo__nombre').textContent;
      const mostrar = () => (rotulo.textContent = nombre);
      const quitar = () => (rotulo.textContent = '');
      carta.addEventListener('pointerenter', mostrar);
      carta.addEventListener('focus', mostrar);
      carta.addEventListener('pointerleave', quitar);
      carta.addEventListener('blur', quitar);
    });

    const desdeHash = () => botones.find((b) => `#${b.dataset.p5Tipo}` === location.hash.replace('#tarjeta-', '#'));
    const inicial = desdeHash();
    if (inicial) {
      guia.dataset.elegida = '';
      aplicar(inicial.dataset.p5Tipo);
      requestAnimationFrame(() => destino.scrollIntoView({ block: 'start', behavior: 'instant' }));
    }
    addEventListener('hashchange', () => {
      const elegido = desdeHash();
      if (elegido && elegido.dataset.p5Tipo !== tipoActual) aplicar(elegido.dataset.p5Tipo);
    });

    let enCurso = 1;
    const activar = (n) => {
      if (n === enCurso) return;
      enCurso = n;
      escena.dataset.n = n;
      pasos.forEach((p) => p.classList.toggle('p5-actual', +p.dataset.n === n));
      pantallas.forEach((p) => p.classList.toggle('p5-activa', +p.dataset.n === n));
    };

    /* Escritorio: manda el paso con el centro más cerca del centro de
       la ventana. Móvil: el último que ha asomado bajo el móvil fijo. */
    const ancho = matchMedia('(min-width: 990px)');
    let pendiente = false;
    const medir = () => {
      pendiente = false;
      let n = 1;
      if (ancho.matches) {
        let mejor = Infinity;
        for (const p of pasos) {
          const r = p.getBoundingClientRect();
          const distancia = Math.abs(r.top + r.height / 2 - innerHeight / 2);
          if (distancia < mejor) [mejor, n] = [distancia, +p.dataset.n];
        }
      } else {
        const bajoEscena = escena.getBoundingClientRect().bottom;
        const linea = bajoEscena + (innerHeight - bajoEscena) * 0.5;
        for (const p of pasos) if (p.getBoundingClientRect().top <= linea) n = +p.dataset.n;
      }
      activar(n);
    };
    pasos[0].classList.add('p5-actual');
    document.addEventListener('scroll', () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(medir);
    }, { capture: true, passive: true });
    addEventListener('resize', medir, { passive: true });
    medir();
  }

  /* 10. Cómo funciona (templates/page.como-funciona.json). La demo va
         pasando sola por reseña, seguidor, carta y WiFi, un bucle de 7 s
         cada una, hasta que el visitante elige; la pastilla se desliza
         como en los filtros de la tienda. En «De seis pasos a dos», al
         llegar, pasa sola a «Con la tarjeta» y los pasos que sobran se
         van como líneas de la cesta. */
  const comoFunciona = document.querySelector('[data-p5-cf]');
  if (comoFunciona) {
    const grupo = comoFunciona.querySelector('.p5-cf__usos');
    const pastilla = grupo.querySelector('.p5-filtros__pastilla');
    const chips = [...grupo.querySelectorAll('[data-p5-uso]')];
    const variantes = [...comoFunciona.querySelectorAll('[data-para]')];
    /* Las notas comparten celda y solo cambian de opacidad: la altura es
       siempre la de la más larga y no se mueve nada al cambiar (CLS) */
    const notas = [...comoFunciona.querySelectorAll('[data-nota]')];
    const demo = comoFunciona.querySelector('[data-p5-cf-demo]');
    const caja = comoFunciona.querySelector('[data-p5-cf-caja]');
    const activo = () => chips.find((c) => c.getAttribute('aria-pressed') === 'true');
    let automatico = !reducido;
    let reloj;

    const arrancar = () => {
      demo.classList.remove('p5-anda');
      void demo.offsetWidth;
      if (!reducido) demo.classList.add('p5-anda');
    };

    const elegir = (chip) => {
      const uso = chip.dataset.p5Uso;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      colocarPastilla(pastilla, chip);
      grupo.scrollTo({ left: chip.offsetLeft - (grupo.clientWidth - chip.offsetWidth) / 2, behavior: reducido ? 'auto' : 'smooth' });
      variantes.forEach((v) => (v.hidden = !v.dataset.para.split(' ').includes(uso)));
      notas.forEach((n) => n.classList.toggle('p5-on', n.dataset.nota === uso));
      arrancar();
    };

    const siguiente = () => {
      if (!automatico) return;
      elegir(chips[(chips.indexOf(activo()) + 1) % chips.length]);
    };

    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        automatico = false;
        clearInterval(reloj);
        if (chip !== activo()) elegir(chip);
      })
    );

    colocarPastilla(pastilla, activo());
    new ResizeObserver(() => colocarPastilla(pastilla, activo())).observe(grupo);
    requestAnimationFrame(() => (grupo.dataset.listo = ''));
    arrancar();

    /* Solo corre (y solo avanza) mientras se ve */
    new IntersectionObserver(([e]) => {
      demo.classList.toggle('p5-en-vista', e.isIntersecting);
      clearInterval(reloj);
      if (e.isIntersecting && automatico) {
        arrancar();
        reloj = setInterval(siguiente, 7000);
      }
    }, { threshold: 0.35 }).observe(demo);

    const modos = comoFunciona.querySelector('.p5-cf__modos');
    const pastillaModo = modos.querySelector('.p5-filtros__pastilla');
    const botonesModo = [...modos.querySelectorAll('[data-p5-modo]')];
    let tocado = false;
    const ponerModo = (boton) => {
      botonesModo.forEach((b) => b.setAttribute('aria-pressed', String(b === boton)));
      colocarPastilla(pastillaModo, boton);
      caja.dataset.modo = boton.dataset.p5Modo;
    };
    botonesModo.forEach((b) =>
      b.addEventListener('click', () => {
        tocado = true;
        ponerModo(b);
      })
    );
    colocarPastilla(pastillaModo, botonesModo[0]);
    new ResizeObserver(() => colocarPastilla(pastillaModo, botonesModo.find((b) => b.getAttribute('aria-pressed') === 'true'))).observe(modos);
    requestAnimationFrame(() => (modos.dataset.listo = ''));

    new IntersectionObserver(([e], obs) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      if (!reducido) setTimeout(() => !tocado && ponerModo(botonesModo[1]), 900);
    }, { threshold: 0.6 }).observe(caja);
  }

  /* 11. Sobre nosotros (templates/page.sobre-nosotros.json): cada foto
         se desvela al llegar a ella, como en un reportaje. */
  const reportaje = document.querySelector('[data-p5-sn]');
  if (reportaje && !reducido && 'IntersectionObserver' in window) {
    reportaje.classList.add('p5-sn--preparado');
    const vista = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('p5-visto');
        vista.unobserve(e.target);
      }
    }, { threshold: 0.2 });
    reportaje.querySelectorAll('.p5-sn__foto').forEach((f) => vista.observe(f));
  }

  /* 12. Barra de campaña (sections/placa5-aviso.liquid): la pastilla
         copia el código y lo deja aplicado en la cesta pidiendo
         /discount/CÓDIGO, la misma URL que los enlaces de descuento de
         Shopify. Si la página viene de caché con la campaña ya acabada,
         se oculta aquí. */
  const aviso = document.querySelector('[data-p5-aviso]');
  if (aviso) {
    if (Date.now() > Number(aviso.dataset.fin)) aviso.hidden = true;

    const boton = aviso.querySelector('.p5-aviso__codigo');
    const estado = aviso.querySelector('[data-p5-aviso-estado]');
    let vuelta;

    const marcar = (texto) => {
      boton.dataset.estado = 'hecho';
      estado.textContent = texto;
      clearTimeout(vuelta);
      vuelta = setTimeout(() => delete boton.dataset.estado, 2600);
    };

    boton.addEventListener('click', async () => {
      const codigo = boton.dataset.codigo;
      const copiado = navigator.clipboard
        ? await navigator.clipboard.writeText(codigo).then(() => true, () => false)
        : false;
      if (copiado) marcar(`Código ${codigo} copiado.`);

      // Shopify responde con una redirección que deja la cookie
      // discount_code; con redirect: 'manual' llega como opaqueredirect
      const aplicado = await fetch(`/discount/${encodeURIComponent(codigo)}`, { redirect: 'manual', credentials: 'same-origin' })
        .then((r) => r.type === 'opaqueredirect' || r.ok, () => false);
      if (aplicado) marcar(`Código ${codigo} aplicado a tu cesta${copiado ? ' y copiado' : ''}.`);
    });
  }

  /* 13. Guía en la home (sections/placa5-guia.liquid): el panel entra al
         asomar y, con ratón, la tableta se inclina hacia el cursor. */
  const guiaHome = document.querySelector('[data-p5-guia-home]');
  if (guiaHome && 'IntersectionObserver' in window && !reducido) {
    guiaHome.classList.add('p5-guia--preparada');
    const vista = new IntersectionObserver(
      (entradas) => {
        if (!entradas.some((e) => e.isIntersecting)) return;
        guiaHome.classList.add('p5-visto');
        vista.disconnect();
      },
      { threshold: 0.2 }
    );
    vista.observe(guiaHome);

    const portada = guiaHome.querySelector('.p5-guia__portada');
    portada.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const caja = portada.getBoundingClientRect();
      const x = (e.clientX - caja.left) / caja.width;
      const y = (e.clientY - caja.top) / caja.height;
      portada.style.setProperty('--rx', `${((0.5 - y) * 8).toFixed(2)}deg`);
      portada.style.setProperty('--ry', `${((x - 0.5) * 12).toFixed(2)}deg`);
    });
    portada.addEventListener('pointerleave', () => {
      portada.style.setProperty('--rx', '0deg');
      portada.style.setProperty('--ry', '0deg');
    });
  }
})();
